import {
  AdminWorkHistory,
  ApiResponse,
  CreateWorkHistoryRequest,
  PaginationParams,
  UpdateWorkHistoryRequest,
} from "../../types/admin";
import httpClient from "../httpClient";
import { sanitizeArrayResponse } from "./helpers";

export const workHistoryApi = {
  getAll: async (params?: PaginationParams): Promise<ApiResponse<AdminWorkHistory[]>> => {
    const response = await httpClient.get<AdminWorkHistory[]>("/work-history", params);
    return sanitizeArrayResponse(response);
  },

  getById: (id: string | number): Promise<ApiResponse<AdminWorkHistory>> =>
    httpClient.get(`/work-history/${id}`),

  create: (item: CreateWorkHistoryRequest): Promise<ApiResponse<AdminWorkHistory>> =>
    httpClient.post("/work-history", item),

  update: (id: string | number, item: UpdateWorkHistoryRequest): Promise<ApiResponse<AdminWorkHistory>> =>
    httpClient.put(`/work-history/${id}`, item),

  delete: (id: string | number): Promise<ApiResponse<void>> =>
    httpClient.delete(`/work-history/${id}`),
};
